import React, { useState, useEffect, useContext } from "react";
import {
  AppBar,
  IconButton,
  Toolbar,
  Drawer,
  Button,
  Avatar,
  useMediaQuery,
} from "@mui/material";
import {
  Menu,
  AccountCircle,
  Brightness4,
  Brightness7,
} from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Search, Sidebar } from "..";
import { ColorModeContext } from "../../utils/ToggleColorMode";
import { setUser, userSelector } from "../../features/auth";
import { fetchToken, createSessionId, moviesApi } from "../../utils";
import useStyles from "./styles";

const NavBar = () => {
  const { isAuthenticated, user } = useSelector(userSelector);
  const [mobileOpen, setMobileOpen] = useState(false); //* Mobile Right side drawer flag
  const { classes } = useStyles(); //* styles hook
  const isMobile = useMediaQuery("(max-width:600px)"); //* MUI property tells if it's mobile device or not
  const theme = useTheme(); //* tells theme of screen
  const dispatch = useDispatch();
  const colorMode = useContext(ColorModeContext);

  const token = localStorage.getItem("request_token");
  const sessionIdFromLocalStorage = localStorage.getItem("session_id");

  useEffect(() => {
    const logInUser = async () => {
      if (token) {
        try {
          if (sessionIdFromLocalStorage) {
            const { data: userData } = await moviesApi.get(`/account?session_id=${sessionIdFromLocalStorage}`);

            dispatch(setUser(userData));
          } else {
            const sessionId = await createSessionId();

            const { data: userData } = await moviesApi.get(`/account?session_id=${sessionId}`);

            dispatch(setUser(userData));
          }
        } catch (error) {
          // Token was never approved on TMDB, expired, or the session is invalid — clear it so we stop retrying.
          localStorage.removeItem("request_token");
          localStorage.removeItem("session_id");
          console.log("Sorry, your login attempt could not be completed.");
        }
      }
    };

    logInUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <>
      <AppBar position="fixed">
        <Toolbar className={classes.toolbar}>
          {/* Menu Button for mobile devices */}
          {isMobile && (
            <IconButton
              color="inherit"
              edge="start"
              className={classes.menuButton}
              onClick={() => setMobileOpen((prevMobileOpen) => !prevMobileOpen)}
            >
              <Menu />
            </IconButton>
          )}
          {/* End of Mobile menu Button */}

          {/* Theme Toggle Button */}
          <IconButton color="inherit" sx={{ ml: 1 }} onClick={colorMode.toggleColorMode}>
            {theme.palette.mode === "dark" ? <Brightness7 /> : <Brightness4 />}
          </IconButton>
          {/* End of theme toggle button */}

          {/* Search for Web */}
          {!isMobile && <Search />}

          {/* Shows Login Button if user is not authenticated else shows Avatar */}
          <div>
            {!isAuthenticated ? (
              <Button color="inherit" onClick={fetchToken}>
                Login &nbsp; <AccountCircle />
              </Button>
            ) : (
              <Button
                color="inherit"
                component={Link}
                to={`/profile/${user.id}`}
                className={classes.linkButton}
              >
                {!isMobile && <>My Movies &nbsp;</>}
                <Avatar
                  style={{ width: 30, height: 30 }}
                  alt="Profile"
                  src={`https://www.themoviedb.org/t/p/w64_and_h64_face${user?.avatar?.tmdb?.avatar_path}`}
                />
              </Button>
            )}
          </div>

          {/* Search for Web */}
          {isMobile && <Search />}
        </Toolbar>
      </AppBar>
      {/* Side bar */}
      <div>
      <nav nav className={classes.drawer}>
      {/* Mobile devices Drawer */}
      {isMobile ? (
        <Drawer 
              variant="temporary"
              anchor="right"
              open={mobileOpen}
              onClose={() => setMobileOpen((prevMobileOpen) => !prevMobileOpen)}
              classes={{ paper: classes.drawerPaper }}
              ModalProps={{ keepMounted: true }}
            >
        <Sidebar setMobileOpen ={setMobileOpen}/>
        </Drawer>
      ):(
        <Drawer
          classes={{paper:classes.drawerPaper}}
          variant ="permanent"
          open
        >
        <Sidebar setMobileOpen ={setMobileOpen}/>
        </Drawer>
      )}

      </nav>

      </div>
    </>
  );
};

export default NavBar;
